/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { GcpDiskSettings } from '../models/GcpDiskSettings';

export class RestoreGcpInstanceDiskInput {
  /**
  * Cloud-provider-assigned ID of the disk to restore.
  */
  'providerDiskId': string;
  'settings': GcpDiskSettings;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "providerDiskId",
      "baseName": "providerDiskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "settings",
      "baseName": "settings",
      "type": "GcpDiskSettings",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreGcpInstanceDiskInput.attributeTypeMap;
  }

  public constructor() {
  }
}

